import axios from "axios";

axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

axios.defaults.baseURL = "http://localhost:8000/"
// axios.defaults.baseURL = "https://api.asakeeb.com/"